import moment from 'moment';


export function utcToDateWithoutLosingDateValue(date: string): Date {
    return moment(date?.split('T')[0]).startOf('day')?.toDate();
}